import CIcon from '@coreui/icons-react'
import { CNavItem, CNavLink, CSidebar, CSidebarBrand, CSidebarToggler } from '@coreui/react-pro'
import { Button, ButtonBase, Drawer, SwipeableDrawer } from '@mui/material'
import { NavLink } from 'react-router-dom'
import styled from 'styled-components'

export const StyledBusinessSidebar = styled(CSidebar)`
  overflow: hidden !important;
  box-shadow: none !important;
  border-radius: 0 24px 24px 0;
  color: ${({ theme, themeType }) =>
    themeType === 'dark' ? theme.dark.sidebarText : theme.light.sidebarText};
  background: ${({ theme, themeType }) =>
    themeType === 'dark' ? theme.dark.bgSidebar : theme.light.bgSidebar};
  padding: 24px 0;
  display: flex !important;
  flex-direction: column !important;

  .sidebar-nav {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
    overflow: hidden;
  }
`
export const SidebarToggler = styled(CSidebarToggler)`
  background-color: transparent;
  transition: background-color 100ms linear;
`
export const StyledSidebarNavItem = styled(CNavItem)`
  display: flex;
  justify-content: start;
  gap: 12px;
  border-radius: 12px;
  width: 100%;
  max-width: 220px;
  cursor: pointer;
  margin-bottom: 2px;
`

export const StyledSidebarNavButton = styled(ButtonBase)`
  display: flex !important;
  justify-content: start !important;
  align-items: center !important;
  gap: 12px;
  border-radius: 12px !important;
  width: 100%;
  max-width: 220px;
  padding: 10px 16px !important;
  cursor: pointer;
  background: transparent;
  transition: background-color 0.15s ease;
  color: rgba(255, 255, 255, 0.9) !important;

  &:hover {
    background-color: rgba(255, 255, 255, 0.12) !important;
  }
`

export const StyledNavLink = styled(NavLink)`
  padding: 10px 16px !important;
  display: flex;
  justify-content: start;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  border-radius: 12px !important;
  color: rgba(255, 255, 255, 0.9) !important;
  text-decoration: none !important;
  font-weight: 500;
  transition: background-color 0.15s ease, color 0.15s ease;

  &:hover {
    background-color: rgba(255, 255, 255, 0.12) !important;
    color: #fff !important;
  }

  &.active {
    background-color: rgba(255, 255, 255, 0.2) !important;
    color: #fff !important;
  }
`
export const StyledNavLinkButton = styled(CNavLink)`
  padding: 10px 1rem !important;
  color: #fff !important;
  display: flex;
  justify-content: start;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  &:hover {
    color: #fff;
  }
`
export const StyledSidebarSimplebar = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 24px 20px 16px;
  gap: 4px;
`
export const StyledSidebarSimplebarLogout = styled.div`
  flex-shrink: 0;
  padding: 16px 20px 24px;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
`

export const StyledNavName = styled.div`
  font-size: 15px;
  font-weight: 500;
`
export const StyledSideBarIcon = styled(CIcon)`
  width: 24px !important;
  height: 24px !important;
  font-size: 24px !important;
  flex-shrink: 0;
`
export const SidebarBrand = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
  padding: 0 16px 20px;
`
export const SidebarBrandImage = styled.img`
  width: 44px;
  height: 44px;
  flex-shrink: 0;
  border-radius: 10px;
  cursor: pointer;
  object-fit: contain;
`
export const SidebarBrandText = styled.div`
  font-family: 'heroregular', system-ui, sans-serif;
  font-weight: 700;
  font-size: 20px;
  letter-spacing: -0.02em;
`
export const ProfileHeader = styled.div``

export const BusinessPaywallDrawer = styled(SwipeableDrawer)``

export const BusinessHeader = styled.header`
  position: sticky;
  top: 0px;
  z-index: 999;
  padding: 12px 0 14px 0 !important;
  background: ${({ themeType }) =>
    themeType === 'dark' ? 'rgba(18, 18, 22, 0.92)' : 'rgba(255, 255, 255, 0.92)'};
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  box-shadow: ${({ themeType }) =>
    themeType === 'dark'
      ? '0 1px 0 rgba(255, 255, 255, 0.06)'
      : '0 1px 0 rgba(0, 0, 0, 0.04)'};
  box-sizing: border-box;
  border-bottom: 1px solid
    ${({ themeType }) => (themeType === 'dark' ? 'rgba(255, 255, 255, 0.06)' : 'rgba(0, 0, 0, 0.06)')};
  transition: background 0.2s ease, box-shadow 0.2s ease;

  @media (min-width: 600px) {
    padding: 16px 0 18px 0 !important;
  }
`
